module.exports = __webpack_public_path__ + "static/media/img_item_02.0019f6ef.png";